import React from 'react';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { useSoundOutWords } from 'state/hooks/use-sound-out-words';
import { getWordAndPunctuation } from 'util/get-words-and-punctuation';
import { FONT_GSS_FUTURA_SEMI_BOLD } from '@monorepo/shared/src/themes/defaultTheme';

type SentenceProps = {
  sentence: string;
  indexOffset: number;
};

const Sentence: React.FC<SentenceProps> = ({ sentence, indexOffset }) => {
  const classes = useStyles();
  const [{ orderedWords, selectedWord }, { setSelectedWord }] = useSoundOutWords();

  return (
    <>
      {sentence.split(' ').map((word: string, index: number) => {
        const { wordToDisplay, punctuationMark } = getWordAndPunctuation(word);
        const wordIndex = index + indexOffset;
        const spellableWord = orderedWords.map(({ order }) => order).includes(wordIndex);
        const isSelectedWord = selectedWord.index === wordIndex;

        return (
          <div className={classes.wordContainer} key={wordIndex}>
            <button
              className={`${classes.word} ${spellableWord ? classes.highlighted : ''} ${
                isSelectedWord ? classes.underlined : ''
              }`}
              key={wordIndex}
              onClick={() => setSelectedWord(wordIndex)}
            >
              {wordToDisplay}
            </button>
            <span className={classes.punctuationMark}>{punctuationMark}</span>
          </div>
        );
      })}
    </>
  );
};

export default Sentence;

const useStyles = makeStyles((theme: Theme) => ({
  wordContainer: {
    flexShrink: 0,
  },
  word: {
    padding: '0 5px;',
    backgroundColor: 'transparent',
    border: 'none',
    fontFamily: FONT_GSS_FUTURA_SEMI_BOLD,
    fontSize: theme.typography.pxToRem(32),
    lineHeight: theme.typography.pxToRem(48),
  },
  punctuationMark: {
    fontFamily: FONT_GSS_FUTURA_SEMI_BOLD,
    fontSize: theme.typography.pxToRem(32),
    lineHeight: theme.typography.pxToRem(48),
  },
  highlighted: {
    color: theme.palette.secondary.dark,
    cursor: 'pointer',
  },
  underlined: {
    textDecoration: 'underline',
  },
}));
